import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  DropdownModule,
  FormAlertModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { AddSqaComponent } from './add-sqa.component';
@NgModule({
  declarations: [AddSqaComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AlertWarningModule,
    ButtonModule,
    InputModule,
    LoginHeaderModule,
    FormAlertModule,
    DropdownModule
  ],
  exports: [AddSqaComponent, LogoHeaderModule],
  providers: [FormGroupDirective]
})
export class AddSqaModule {}
